import { notifyUser } from './notifyUser';
import { NotifyType } from './types';

const notifyUserWithError = (errMsg: string) =>
  notifyUser({
    msg: errMsg,
    type: NotifyType.ERROR
  });

const notifyServerError = (e: any) => {
  try {
    notifyUserWithError(e.response.data.error.message.value);

    return true;
  } catch {
    return false;
  }
};

export const notifyError = (e: any, defaultMsg?: string) => {
  try {
    const serverNotified = notifyServerError(e);

    if (serverNotified) return;

    if (e.message) {
      notifyUserWithError(e.message);

      return null;
    }

    throw new Error();
  } catch {
    notifyUserWithError(defaultMsg || 'Error');
  }
};
